__turbopack_context__.v({
  "base": "SzVwOG_base",
  "icon-pulse": "SzVwOG_icon-pulse",
  "icon-spin": "SzVwOG_icon-spin",
  "pulse": "SzVwOG_pulse",
  "size2xl": "SzVwOG_size2xl",
  "size2xs": "SzVwOG_size2xs",
  "sizeLg": "SzVwOG_sizeLg",
  "sizeMd": "SzVwOG_sizeMd",
  "sizeSm": "SzVwOG_sizeSm",
  "sizeXl": "SzVwOG_sizeXl",
  "sizeXs": "SzVwOG_sizeXs",
  "spin": "SzVwOG_spin",
});
